export const V2_WORKFLOWS_URL = 'workflow/v2';

export const apiRouteV2 = {
  'continue-autoflow-intent': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/continue-autoflow-intent`,
  },
  'conversation-oauth-credential-status': {
    method: 'get',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/oauth/{conversationOauthCredentialId}/status`,
  },
  'get-translated-csat-text': {
    method: 'get',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/csat-text`,
  },
  'get-widget-components': {
    method: 'get',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/widget-components`,
  },
  'handle-sunco-multi-convo-disabled': {
    method: 'post',
    url: '/sunshine/multi-convo',
  },
  'init-intent-conversation': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/conversation`,
  },
  'interactive-email-deflection-feedback': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/interactive-email-conversation/{conversationId}/deflection-feedback`,
  },
  'restart-intent-conversation': {
    method: 'put',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/restart`,
  },
  'search-knowledge': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/knowledge/search`,
  },
  'search-knowledge-click': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/knowledge/click`,
  },
  'send-conversation-alert': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/alert`,
  },
  'send-conversation-feedback': {
    method: 'put',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/feedback`,
  },
  'send-free-form-query': {
    method: 'put',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/free-form-query`,
  },
  'send-sip-call-event': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/sip-call-event/{callEventType}`,
  },
  'submit-intent-csat': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/csat`,
  },
  'update-helpdesk-conversation': {
    method: 'post',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}/update-helpdesk-conversation`,
  },
  'update-intent-conversation': {
    method: 'put',
    url: `/${V2_WORKFLOWS_URL}/conversation/{conversationId}`,
  },
} as const;
